import React, { useEffect, useState } from "react"
import Development from "../development-card"
import Loading from "../Loading"
import { connect } from "react-redux"
import {
  getDevelopmentsFilterAction,
  updateFiltersDevelopment,
} from "../../redux/developmentsDucks"
import { getReverseOrder } from "../../helpers/helper.developments"
import { useGetDevelopmentsQuery } from "../../redux/middlewareTokkoApi/developments"
import { useGetDevelopmentsQuery as useGetDeveolpmentsMediacoreQuery } from "../../redux/mediacore/emprendimientos"
import { graphql, useStaticQuery } from "gatsby"
import useQueryDevelopments from "../../hooks/useQueryDevelopments"

const DICCIONARIO = {
  "ver todos": 1,
  "pre-Venta": 2,
  "en pozo": 3,
  "en construcción": 4,
  "terminado": 5,
}

const Developments = ({
  developmentsFilters,
  developments,
  loading,
  api_key,
  tag,
  dispatch,
}) => {
  const { realEstate } = useStaticQuery(graphql`
    query {
      realEstate {
        keys {
          tokko
        }
        env {
          CLIENTID
        }
      }
    }
  `)

  const [filter, setFilter] = useState("VER TODOS")
  const [buttons, setButtos] = useState([])

  const {
    allDevelopmentsData,
    isLoading,
    isError,
  } = useQueryDevelopments()
  // const { data: allDevelopmentsData, isLoading, isError } = useGetDeveolpmentsMediacoreQuery({"CLIENT_ID":realEstate.env.CLIENT_ID});

  console.log(allDevelopmentsData)

  useEffect(() => {
    if (api_key) {
      dispatch(updateFiltersDevelopment(filter))
      dispatch(getDevelopmentsFilterAction()) // Get all developments
    }
  }, [filter, api_key])

  const getStatusByDevelopments = () => {
    let status = [
      {
        name: "VER TODOS",
        value: 0,
      },
    ]
    if (allDevelopmentsData && !isLoading) {
      for (const iterator of allDevelopmentsData) {
        if (
          !status.find(
            s =>
              s?.name?.toLowerCase() ===
              convertStatusIdToString(
                iterator?.construction_status
              ).toLowerCase()
          )
        ) {
          status.push({
            name: convertStatusIdToString(iterator.construction_status),
            value: status.length + 1,
          })
        }
      }
    }
    return status
  }

  const convertStatusIdToString = statusId => {
    switch (statusId) {
      case 3:
        return "EN POZO"
      case 4:
        return "EN CONSTRUCCIÓN"
      case 6:
        return "TERMINADO"
      default:
        return statusId.toUpperCase()
    }
  }

  console.log(buttons)

  useEffect(() => {
    if (allDevelopmentsData) {
      setButtos(getStatusByDevelopments())
    }
  }, [allDevelopmentsData])

  const checkTag = developments => {
    //Function to check if this page has a tag
    const development_array = developments;
    if (tag) {
      return development_array.filter(
        element =>
          element.custom_tags.find(
            c_tag => c_tag.name.replaceAll(" ", "-").toLowerCase() === tag
          ) &&
          !element.custom_tags.find(tag => tag.name.toLowerCase() === "portada")
      )
    }
    if (filter.toLowerCase() === "ver todos") {
      return development_array
    }
    return development_array.filter(d => d.construction_status.toLowerCase() === filter.toLowerCase()) // Nuevo por strings
    // return development_array.filter(
    //   element =>
    //     !element.custom_tags.find(tag => tag.name.toLowerCase() === "portada")
    // )
  }

  return (
    <section
      id="featured-devs"
      className={
        "pt-lg-5 " +
        (!isLoading && allDevelopmentsData?.length === 0 ? "d-none" : "")
      }
    >
      <div className={"container-fluid my-5 pb-lg-3"}>
        <div className={"d-flex flex-wrap justify-content-center "}>
          {isLoading ? (
                    <>
                      {[1, 2, 3, 4].map(button => (
                        <button
                          className={"button-filter mb-2 mb-lg-0 skeleton "}
                        >
                          XXXXXXXX
                        </button>
                      ))}
                    </>
                  ) : (
                    buttons
                      .sort((a, b) => DICCIONARIO[a.name] - DICCIONARIO[b.name])
                      .map(
                        (button, index) => (
                          <button
                            className={
                              "button-filter text-uppercase mb-2 mb-lg-0 " +
                              (filter === button.name ? " active " : "")
                            }
                            onClick={() => setFilter(button.name)}
                          >
                            {button.name}
                          </button>
                        )
                        // )
                      )
                  )}
        </div>
      </div>
      {
        <div className="container-fluid asdasd">
          <div className="row no-gutters mt-5 mt-lg-1 mb-lg-4">
            {!isLoading ? (
              checkTag(allDevelopmentsData)?.length > 0 ? (
                checkTag(allDevelopmentsData).map((development, index) => (
                  <div
                    class={
                      index +
                      " mb-3 mb-lg-4 pb-lg-2 px-lg-3 " +
                      (checkTag(allDevelopmentsData)?.length === 1
                        ? "col-lg-12 " //Si es uno solo, 100%
                        : checkTag(allDevelopmentsData)?.length < 9 &&
                          index === 0 &&
                          checkTag(allDevelopmentsData)?.length % 2 === 1
                        ? "col-lg-12 " // Si impares menor a 9, el primero 100%
                        : checkTag(allDevelopmentsData)?.length < 9
                        ? "col-lg-6" //Si menores a 9, 50%
                        : checkTag(allDevelopmentsData)?.length >= 9 &&
                          checkTag(allDevelopmentsData)?.length % 3 === 1 &&
                          index === 0
                        ? "col-lg-12" // Si es mayor o igual a 9, y sobra 1, 100% el primero
                        : checkTag(allDevelopmentsData)?.length >= 9 &&
                          checkTag(allDevelopmentsData)?.length % 3 === 2 &&
                          (index === 0 || index === 1)
                        ? "col-lg-6" // Si son 9 o mas, y sobran 2, los primeros 2, 50%
                        : "col-lg-4") // Si son 9 o mas, 33,3%
                    }
                  >
                    <Development key={index} development={development} />
                  </div>
                ))
              ) : (
                <h4 className="text-center">
                  {/* No hay emprendimientos{" "}
                  {filter !== 0 &&
                    buttons
                      .find(element => element.value === filter)
                      .name?.toLowerCase()} */}
                </h4>
              )
            ) : (
              [1, 2, 3].map(index => (
                <div className="col-lg-4">
                  <Development skeleton={true} />
                </div>
              ))
            )}
          </div>
        </div>
      }
    </section>
  )
}
export default connect(
  state => ({
    developmentsFilters: state.developments.developmentsFilters,
    loading: state.developments.loading,
    api_key: state.settings.keys.tokko,
  }),
  null
)(Developments)
